import {differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds} from 'date-fns'

export function datesDiffToString(date: Date) {
  const currentDate = new Date()

  const seconds = differenceInSeconds(currentDate, date)
  const minutes = differenceInMinutes(currentDate, date)
  const hours = differenceInHours(currentDate, date)
  const days = differenceInDays(currentDate, date)

  return {days, hours, minutes, seconds}
}

export function formatDateTime(dateString: string): {formattedDate: string; formattedTime: string} {
  const date = new Date(dateString)
  const utcDate = new Date(date.toISOString().replace('Z', ''))
  const localeDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000)
  const day = String(localeDate.getDate()).padStart(2, '0')
  const month = String(localeDate.getMonth() + 1).padStart(2, '0')
  const year = localeDate.getFullYear()
  const hours = String(localeDate.getHours()).padStart(2, '0')
  const minutes = String(localeDate.getMinutes()).padStart(2, '0')
  const seconds = String(localeDate.getSeconds()).padStart(2, '0')

  return {
    formattedDate: `${day}/${month}/${year}`,
    formattedTime: `${hours}:${minutes}:${seconds}`,
  }
}

export function fileDateFormat(date: string): string {
  const dateFormatted = date.replace(/_/g, ':').replace('T', ' ').replace('.000Z', '').slice(0, 10)
  const year = dateFormatted.slice(0, 4)
  const month = dateFormatted.slice(5, 7)
  const day = dateFormatted.slice(8, 10)

  return `${day}-${month}-${year}`
}

export const TODAY = new Date()
export const PAST_WEEK = new Date(new Date().setHours(new Date().getDate() - 7))
export function getUTCDate(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() - 3, date.getMinutes(), date.getSeconds())
}
export function getStartDateTime(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), -3, 0, 0)
}
